export default __webpack_public_path__ + "static/media/bapmPreview.b6e907a5.jpg";